import { useState } from 'react';

import { ModalBase } from '../../../components/modals/ModalBase';

import type { InsightFalseFeedbackReason } from '../../../types';
import type React from 'react';

// D4 — motivo é enum (snake_case canônico). Rótulos PT casam o contrato real do FalsePositiveDto.
const REASON_OPTS: { value: InsightFalseFeedbackReason; label: string }[] = [
  { value: 'incorrect_data', label: 'Dados incorretos' },
  { value: 'inadequate_conclusion', label: 'Conclusão inadequada' },
  { value: 'already_treated', label: 'Já foi tratado' },
  { value: 'missing_context', label: 'Falta contexto' },
  { value: 'other', label: 'Outro' },
];

const FEEDBACK_MAX = 2000;

export interface FalsePositiveModalProps {
  open: boolean;
  isPending: boolean;
  failed: boolean;
  outcome: string | null;
  onClose: () => void;
  onConfirm: (args: { reason: InsightFalseFeedbackReason; feedbackText?: string }) => void;
}

export function FalsePositiveModal({
  open,
  isPending,
  failed,
  outcome,
  onClose,
  onConfirm,
}: FalsePositiveModalProps): React.JSX.Element | null {
  const [reason, setReason] = useState<InsightFalseFeedbackReason>('incorrect_data');
  const [feedback, setFeedback] = useState('');
  if (!open) return null;

  const trimmed = feedback.trim();
  const submit = (): void =>
    onConfirm({ reason, ...(trimmed.length > 0 ? { feedbackText: trimmed } : {}) });

  return (
    <ModalBase
      open={open}
      onClose={onClose}
      title="Marcar como falso positivo"
      width={520}
      footer={
        <div style={{ display: 'flex', gap: 8, marginLeft: 'auto' }}>
          <button className="btn-ghost-mini" type="button" onClick={onClose} disabled={isPending}>
            Cancelar
          </button>
          <button
            className="btn-ghost-mini btn-ghost-mini--primary"
            type="button"
            disabled={isPending}
            onClick={submit}
          >
            {isPending ? 'Enviando…' : 'Marcar falso positivo'}
          </button>
        </div>
      }
    >
      <div className="modal-form">
        <p>O agente é realimentado com este motivo para refinar futuros insights.</p>
        <label className="modal-form__field">
          <span className="modal-form__label">Motivo</span>
          <select
            className="modal-form__select"
            value={reason}
            onChange={(e) => setReason(e.target.value as InsightFalseFeedbackReason)}
          >
            {REASON_OPTS.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </label>
        <label className="modal-form__field">
          <span className="modal-form__label">Detalhe (opcional · máx {FEEDBACK_MAX})</span>
          <textarea
            className="modal-form__textarea"
            value={feedback}
            maxLength={FEEDBACK_MAX}
            onChange={(e) => setFeedback(e.target.value)}
            rows={3}
            placeholder="O que tornou este insight incorreto…"
          />
        </label>
        {failed && (
          <div className="banner banner--danger" role="alert">
            <div className="banner__body">
              <span className="banner__title">Não foi possível enviar o feedback.</span>
            </div>
          </div>
        )}
        {outcome !== null && (
          <div className="modal-form__callout" role="status">
            {outcome}
          </div>
        )}
      </div>
    </ModalBase>
  );
}
